import { createContext, ReactNode, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export enum NOTIFICATION_TYPE {
  ERROR,
  WARNING,
  SUCCESS,
  LOADING,
}

export type Notification = {
  title: string;
  message: string;
  type: NOTIFICATION_TYPE;
};
export type NotificationState = {
  notification: Notification | null;
  isOpen: boolean | undefined;
  dismissNotification: () => void;
  addNotification: (n: {
    title: string;
    message: string;
    type: NOTIFICATION_TYPE;
  }) => void;
};

const defaultState: NotificationState = {
  notification: null,
  addNotification: () => {},
  isOpen: undefined,
  dismissNotification: () => {},
};

export const NotificationContext =
  createContext<NotificationState>(defaultState);

export const NotificationProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [notification, setNotification] = useState<Notification | null>(null);
  const [isOpen, setIsOpen] = useState<boolean | undefined>(undefined);
  const { pathname } = useLocation();
  useEffect(() => {
    setIsOpen(undefined);
  }, [pathname]);
  const addNotification = ({
    title,
    message,
    type,
  }: {
    title: string;
    message: string;
    type: NOTIFICATION_TYPE;
  }) => {
    setNotification({
      title,
      message,
      type,
    });
    setIsOpen(true);
  };

  const dismissNotification = () => {
    setIsOpen(undefined);
  };
  const value = {
    notification,
    addNotification,
    dismissNotification,
    isOpen,
  };
  return (
    <NotificationContext.Provider value={value}>
      {children}
    </NotificationContext.Provider>
  );
};
